export default function partnerLoadMore () {
/* Partner Load More */
  const loadMoreButton = document.querySelector('.partner__articles__loadmore-button')
  const loadMoreContainer = document.querySelector('.partner__articles .articles')
  if (!loadMoreButton || !loadMoreContainer) return
  const loadMoreText = loadMoreButton.innerHTML

  showHideButton(true)

  loadMoreButton.addEventListener('click', function (ev) {
    ev.preventDefault()
    updateButtonText('Please Wait...')
    loadUrl(loadMoreButton.getAttribute('href'))
  })

  function updateButtonText (text) {
    loadMoreButton.innerHTML = text
  }

  function showHideButton (show) {
    if (show) {
      loadMoreButton.classList.remove('hidden')
    } else {
      loadMoreButton.classList.add('hidden')
    }
  }

  function loadUrl (url) {
    const request = new XMLHttpRequest()
    request.open('GET', url, true)
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    request.onload = function () {
      if (request.status === 200) {
        const data = JSON.parse(request.responseText)
        updateArticles(data)
        showHideButton(data.hasMorePages)
        updateButtonText(loadMoreText)
      }
    }
    request.onerror = function () {
      updateButtonText(loadMoreText)
    }
    request.send()
  }

  function updateArticles (data) {
    loadMoreContainer.insertAdjacentHTML('beforeend', data.posts)
    loadMoreButton.setAttribute('href', data.pagination_url)
  }
}
